export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9509.d2309b94.jpg";